import React, { useEffect, useState } from "react";

const LabelPrintingLayout = ({
  id,
  title,
  no,
  weight,
  treatment_type,
  buyPrice,
}) => {
  const [buyPriceCode, setBuyPriceCode] = useState("");

  useEffect(() => {
    let code = ["T", "S", "H", "I", "M", "L", "A", "F", "O", "R"];
    let buyPriceConverted = parseInt(Number(buyPrice || 0) / 360).toString();
    let buyPriceConvertedArray = buyPriceConverted.split("");
    let temCode = "";
    buyPriceConvertedArray.map((x, i) => {
      temCode = temCode + code[x];
    });
    setBuyPriceCode(temCode);
  }, [buyPrice]);

  //New Version

  return (
    <div
      style={{
        width: "25mm",
        height: "20mm",
        marginBottom: "3mm",
        marginRight: "2mm",
        fontSize: 9,
        padding: 5,
      }}
      className="flex flex-col text-bold justify-center bg-white text-black  rounded"
    >
      <div
        style={{
          height: "2mm",
          lineHeight: 1,
          paddingRight: "1mm",
          paddingLeft: "1mm",
        }}
        className="flex w-full justify-between items-center "
      >
        <div style={{ color: "#ff0000" }} className="flex font-extrabold red">
          {id}
        </div>
        <div className="flex ">
          {treatment_type === "Natural"
            ? "N"
            : treatment_type === "Heated"
            ? "H"
            : treatment_type}
        </div>
      </div>
      <div
        style={{ fontSize: "10px", maxHeight: "6mm", lineHeight: 1 , marginTop:'1mm'}}
        className="flex font-extrabold text-center w-full justify-center items-start"
      >
        {title}
      </div>
      <div
        style={{ fontSize: "6px", height: "2mm", lineHeight: 1 }}
        className="flex italic  font-extrabold text-center  w-full justify-center items-center"
      >
        {/* {parseInt(Number(buyPrice || 0 )/360).toString()} */}
        {buyPriceCode}
      </div>
      <div
        style={{ height: "1mm", paddingRight: "1mm", paddingLeft: "1mm" }}
        className="flex w-full justify-between text-bold"
      >
        <div className="flex font-extrabold">#{no}</div>
        <div style={{ color: "#ff0000" }} className="flex red font-extrabold">
          {weight}
        </div>
      </div>
    </div>
  );

  // OLD Version

  // return (
  //   <div style={{width:'19mm',height:'13mm',marginBottom:'3mm', marginRight:'2mm', fontSize:7, padding:5}} className='flex flex-col text-bold text-sm bg-white text-black  rounded'>
  //       <div style={{height:'1mm', lineHeight:1 , paddingRight:"1mm", paddingLeft:"1mm"}}className='flex w-full justify-between items-center '>
  //           <div style={{color:'#ff0000'}} className='flex font-extrabold red'>{id}</div>
  //           <div className='flex '>{treatment_type === "Natural"
  //         ? "N"
  //         : treatment_type === "Heated"
  //         ? "H"
  //         : treatment_type}</div>
  //       </div>
  //       <div style={{fontSize:'6px', height:'5mm' , lineHeight:1}}  className='flex font-extrabold text-center w-full justify-center items-center'>
  //         {title}
  //       </div>
  //       <div style={{fontSize:'5px', height:'1mm' , lineHeight:1}}  className='flex italic  font-extrabold text-center  w-full justify-center items-center'>
  //        {/* {parseInt(Number(buyPrice || 0 )/360).toString()} */}
  //         {buyPriceCode}
  //       </div>
  //       <div style={{height:'1mm', paddingRight:"1mm", paddingLeft:"1mm"}}className='flex w-full justify-between text-bold'>
  //           <div className='flex font-extrabold'>#{no}</div>
  //           <div style={{color:'#ff0000'}} className='flex red font-extrabold'>{weight}</div>
  //       </div>
  //   </div>
  // )
};

export default LabelPrintingLayout;
